import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Claim, ClaimStatus, PetInsuranceData } from "../../../models";
import { Router } from "@angular/router";
import { ApiHttpService } from "../../../services/api-http.service";
import { DocumentViewerService } from "../../../services/document-viewer.service";

@Component({
  selector: 'cpf-claims-details',
  templateUrl: './claims-details.component.html',
  styleUrls: ['./claims-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ClaimsDetailsComponent {
  @Input() claim!: Claim;
  @Input() petData!: PetInsuranceData;
  @Input() showBackButton = true;

  constructor(private router: Router,
              private apiHttpService: ApiHttpService,
              private documentViewerService: DocumentViewerService) {
  }

  navigateBack() {
    this.router.navigate(['calingo', 'pet', 'claims']);
  }

  async openInvoiceDocument() {
    const fnolRequestId = this.claim.fnolRequestId;
    const s3Id = this.claim.invoiceDocument?.s3Id;
    // The whole row is clickable, so entries without a document stay a no-op.
    if (!fnolRequestId || !s3Id) {
      return;
    }

    await this.documentViewerService.openRemoteDocument(async () => {
      const res = await this.apiHttpService.getFileDownloadUrl(fnolRequestId, s3Id);
      return res?.Location;
    }, { fileName: s3Id });
  }

  formatClaimStatus(claim: Claim): "claims-details.status.COMPLETED" | "claims-details.status.OTHER" {
    if (claim.status == ClaimStatus.COMPLETED) {
      return "claims-details.status.COMPLETED";
    }
    return "claims-details.status.OTHER"
  }

  checkClaimStatus(claim: Claim): "completed" | "other" {
    if (claim.status == ClaimStatus.COMPLETED) {
      return "completed";
    }
    return "other"
  }
}
